import { ENVIRONMENTS } from 'Utilities/consts';

import isProd from './isProd';

const isStaging = !isProd && [ENVIRONMENTS.STAGING, ENVIRONMENTS.PRODUCTION].includes(process.env.NODE_ENV);

export default isStaging;
